import {ResizeService} from './resize.service';

export const ResizeInjectables: Array<any> = [
  {
    provide: ResizeService,
    useClass: ResizeService,
  },
];
